import {adminStates} from './../admin-routes';

export default function AdminNavigationService() {
    Object.assign(this, {
        getMenuItems,
    });

    function getMenuItems() {
        return [{
            name: 'Hotel List',
            state: adminStates.HOTEL_LIST,
            count: 0,
        }, {
            name: 'Fax',
            state: adminStates.FAX,
            count: 0,
        }];
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-navigation/admin-navigation-service.js